export default ['None', 'STARTLS', 'SSL', 'SSL/TLS']